import { User, DELIVAI_INTERNAL_CNPJ } from "../config";
import { readLoginAudience } from "./loginAudience";

const INTERNAL_DIGITS = DELIVAI_INTERNAL_CNPJ.replace(/\D/g, "");

/** Colaborador vinculado ao CNPJ interno DelivAI (pode ser loja de teste ou equipe /dev). */
export function isDelivaiInternalCollaborator(user: User | null | undefined): boolean {
  if (!user?.isCollaborator) return false;
  const c = (user.cnpj || "").replace(/\D/g, "");
  return c === INTERNAL_DIGITS;
}

/**
 * Sessão do console interno. Só vale quando o login foi pelo botão Desenvolvedores.
 * Colaborador da loja DelivAI (mesmo CNPJ) entra em /colaborador, não em /dev.
 */
export function isDelivaiDevSession(user: User | null | undefined): boolean {
  if (!user?.isCollaborator) return false;
  const audience = readLoginAudience();
  if (audience === "colaboradores") return false;
  if (audience === "delivai_dev") return true;
  return isDelivaiInternalCollaborator(user);
}

/** Colaborador de loja — inclusive da empresa DelivAI quando o login foi em Colaboradores. */
export function isStoreCollaboratorSession(user: User | null | undefined): boolean {
  if (!user?.isCollaborator) return false;
  return !isDelivaiDevSession(user);
}
